<ng-container *ngIf="this.parkerStateService.modeAddNew == false">
  <app-parker-search-criteria
      (lotChangeNotification)="handleLotChangedEvent($event)"
      (newQueryNotification)="handleNewQueryEvent($event)"
  ></app-parker-search-criteria>
  <app-parkers-v2-search-results></app-parkers-v2-search-results>
</ng-container>

<ng-container *ngIf="this.parkerStateService.modeAddNew == true">
  <!-- <app-company-add-new (signalMinimizeSearchCriteria)="OnHideSearchCriteria(true)"></app-company-add-new> -->
   <app-parkers-v2-add-new-parker></app-parkers-v2-add-new-parker>
</ng-container>